import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';

const useLocalVehicle = () => {
	const localOwnedVehicleId = useObservable(
		rage.vehicles.getLocalOwnedVehicleId(),
	);
	const ownedVehicleList = useObservable(rage.vehicles.getPlayerVehicleList());

	const localOwnedVehicle = useMemo(() => {
		if (!localOwnedVehicleId) return null;
		return ownedVehicleList.find(
			(vehicle) => vehicle.id === localOwnedVehicleId,
		);
	}, [localOwnedVehicleId, ownedVehicleList]);

	return {
		vehicleId: localOwnedVehicle?.id,
		modelId: localOwnedVehicle?.model,
		numberPlate: localOwnedVehicle?.numberPlate,
	};
};

export { useLocalVehicle };
